<template>
	<footer id="footer" class="b360-footer">
		<span class="copyright"
			>Copyright {{ new Date().getFullYear() }}. United Wholesale Mortgage, LLC.
			All Rights Reserved.</span
		>
		<ul class="footer-links">
			<li class="privacy-policy">
				<a @click="showPrivacyPolicy = true">Privacy Policy</a>
			</li>
			<modal
				modalTitle="Privacy Policy"
				class="md legal-modal disable-padding"
				v-if="showPrivacyPolicy"
				cancelBtnName="Close"
				@close="showPrivacyPolicy = false"
				@clicked="showPrivacyPolicy = false"
			>
				<div class="text-modal-copy" slot="modalContent">
					<p class="description-content">
						United Wholesale Mortgage, a division of United Shore Financial
						Services, LLC ("UWM") understands that you expect privacy and
						security for transactions conducted with UWM. This Privacy Policy
						describes the standards UWM follows in handling non-public
						information.
					</p>
					<p class="disclaimer-wrapper">
						<PrivacyPolicy />
					</p>
				</div>
			</modal>

			<li class="terms-of-use">
				<a @click="showTermsOfUse = true">Terms of Use</a>
			</li>
			<modal
				modalTitle="Terms of Use"
				class="md legal-modal disable-padding"
				v-if="showTermsOfUse"
				cancelBtnName="Close"
				@close="showTermsOfUse = false"
				@clicked="showTermsOfUse = false"
			>
				<div class="text-modal-copy" slot="modalContent">
					<p class="disclaimer-wrapper">
						<TermsOfUseSlotComponent />
					</p>
				</div>
			</modal>
			<li><a href="https://www.uwm.com">Powered by UWM</a></li>
		</ul>
	</footer>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Modal from '@/components/global/Modal.vue';
import TermsOfUseSlotComponent from '@/components/legal/TermsOfUseSlotComponent.vue';
import PrivacyPolicy from '@/components/global/PrivacyPolicy.vue';

export default {
	name: 'appFooter',
	components: {
		Modal,
		TermsOfUseSlotComponent,
		PrivacyPolicy,
	},
	data() {
		return {
			showTermsOfUse: false,
			showPrivacyPolicy: false,
		};
	},
};
</script>

<style scoped lang="scss">
.b360-footer {
	display: flex;
	justify-content: center;
	padding: $base-padding;
	background-color: $white;
	border: $b360-border-width-thin solid $border-color-light;
	@include typo--roboto__medium;
	color: $brand-blue;
	font-size: $b360-font-size--small;
	flex-wrap: wrap;

	@media only screen and (max-width: 1105px) {
		flex-direction: column;
		align-items: center;
		text-align: center;

		ul li:first-child:before {
			display: none;
		}
	}

	ul li:not(.no-styles) {
		color: $brand-blue;
		@include rem(font-size, 15px);
		line-height: 1;
		@include mobile-min {
			@include rem(font-size, 12px);
		}
	}

	.footer-links {
		@include rem(margin, 0);
		@include rem(padding-left, 0);
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
	}

	li {
		line-height: 1;
		display: flex;
		align-items: center;
	}

	ul li:before {
		display: inline-block;
		content: '';
		@include rem(height, 5px);
		@include rem(width, 5px);
		@include rem(margin, 0 7px);
		border-radius: 50%;
		background-color: $brand-blue;
	}

	.copyright {
		@include typo--roboto__regular;
		color: $text-base-color;
		@include mobile-min {
			@include rem(font-size, 14px);
			@include rem(margin-bottom, 5px);
		}
	}

	a {
		color: unset;
		text-decoration: unset;
		font-weight: unset;
		cursor: pointer;
	}
}

p.description-content {
	@include rem(margin-top, 0);
	@include rem(padding-bottom, 8px);
	line-height: 1.5;
}

.text-modal-copy {
	@include rem(padding, 0 12px 12px 12px);
	@include rem(margin-bottom, 0);
}

.disclaimer-wrapper {
	width: 100%;
	@include rem(height, 300px);
	@include rem(padding, 8px 0 0 5px);
	list-style-type: none;
	margin: 0;
	border: $b360-border-width-thin solid $border-color-light;
	border-radius: $b360-border-radius-base;
	/* scrolling */
	scroll-snap-type: y proximity;
	overflow: hidden;
	overflow-y: scroll;

	&::-webkit-scrollbar {
		@include rem(width, 2px);
		background: none;
	}

	&::-webkit-scrollbar-thumb {
		background: $brand-blue;
	}
}
</style>
